export default __webpack_public_path__ + "static/media/whiteGithub.79a92ece.svg";